import { useEffect } from 'react'

import { Button } from '@/components/ui/button'
import { Credenza, CredenzaTitle } from '@/components/ui/credenza'
import DynamicCredenzaContent from '@/components/ui/credenza-content'
import { Input } from '@/components/ui/input'
import { Separator } from '@/components/ui/separator'
import { Text } from '@/components/ui/text'
import { useQueryReferrerInfoByReferralCode } from '@/data'
import { useToast } from '@/hooks'
import { useReferralActions } from '@/store'
import { truncateAddress } from '@/utils'

import { useTranslation } from 'react-i18next'

interface ConfirmRegisterReferralProps {
  referralCode: string
  onSubmit: (referralCode: string) => void
  isLoading?: boolean
}
export const ConfirmRegisterReferral = ({ referralCode, onSubmit, isLoading }: ConfirmRegisterReferralProps) => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const { setOpenConfirmRegister } = useReferralActions()
  const {
    data: referrerInfo,
    isLoading: isLoadingReferrerInfo,
    error,
  } = useQueryReferrerInfoByReferralCode({
    referralCode,
  })
  useEffect(() => {
    if (error?.message) {
      toast({
        title: t('error.ERROR'),
        description: error?.message,
        variant: 'destructive',
      })
      setOpenConfirmRegister(false)
    }
  }, [error?.message])

  if (isLoadingReferrerInfo || error?.message) return null
  return (
    <Credenza open={true} onOpenChange={setOpenConfirmRegister}>
      <DynamicCredenzaContent style={{ maxHeight: 'unset' }} open={false} className='py-6 max-w-lg px-6 bg-[#242424]'>
        <CredenzaTitle className='text-center'>
          <Text>{t('title.YOU_HAVE_BEEN_INVITED_BY')}</Text>
        </CredenzaTitle>
        <div>
          <Text className='text-center flex items-center justify-center gap-4' size={22}>
            {truncateAddress(referrerInfo?.createdBy)}
          </Text>
          <Separator className='my-5' />
          <div className='space-y-3 px-[1px]'>
            <Text as='p' color='white-48'>
              {t('title.REFERRAL_CODE')}
            </Text>
            <div>
              <Input
                size='lg'
                disabled
                placeholder={t('title.PASTE_ADDRESS')}
                autoComplete='off'
                autoCorrect='off'
                autoFocus={false}
                value={referralCode}
              />
            </div>
            <Button
              size='lg'
              className='w-full focus-visible:ring-0'
              type='submit'
              onClick={() => onSubmit(referralCode)}
              isLoading={isLoading}
            >
              {t('button.CONFIRM_REFERRAL')}
            </Button>
          </div>
        </div>
      </DynamicCredenzaContent>
    </Credenza>
  )
}
